import {storage} from '../assets/js/tools.js';
import {api} from '../config/api.js';
import {get,post,postForm,postFile,postUrl} from '../config/request.js';
import {cookie,isLogin} from '@/assets/js/tools.js';
import {Message } from "element-ui";
export default{
    data(){
        return{
            storage:storage,
            api:api,
            cookie:cookie,
        }
    },
    methods:{
        post,
        get,
        postForm,
        postFile,
        postUrl,
        routerToUrl(path){
            // if(path=='/communicationPost'){
            //     if(!isLogin()){
            //         return;
            //     }
            // }
            this.$router.push(path);
            
        },
        changePage (val, type) {
            if (type) {
                this.page.targetPage = 1;
                this.page.pageSize = val;
            } else {
                this.page.targetPage = val;
            }
            this.getData();
        },
    }
}